export enum ServiceStatus {
  idle,
  loading,
  succeeded,
  failed,
}
